module.exports = __webpack_public_path__ + "img/password-icon.284b59ba.svg";